export const ContactPage = () => {
    return (
      <div className="container" style={{ minHeight: "80vh", padding: "20px" }}>
        <h1>Contact Us</h1>
        <p>
          Have questions or suggestions? Reach out to us at:
          <br />
          📧 <a href="mailto:bayareaprivateschools@gmail.com">ilovemycats@gmail.com</a>
        </p>
      </div>
    );
  }
  